var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvPlugChademo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0d6efd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 10.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0-1.5c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m8 1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0-1.5c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m-1.88-.59-1.41-1.41 1.41-1.41-.71-.71-1.41 1.41-1.41-1.41-.71.71 1.41 1.41-1.41 1.41.71.71 1.41-1.41 1.41 1.41zm0 10-1.41-1.41 1.41-1.41-.71-.71-1.41 1.41-1.41-1.41-.71.71 1.41 1.41-1.41 1.41.71.71 1.41-1.41 1.41 1.41zm5.62-12.74.76-.74-1.43-1.43-.74.76c-1.73-1.41-3.93-2.26-6.33-2.26s-4.6.85-6.33 2.26l-.74-.76-1.43 1.43.76.74c-1.41 1.73-2.26 3.93-2.26 6.33 0 5.5 4.5 10 10 10s10-4.5 10-10c0-2.4-.85-4.6-2.26-6.33m-7.74 14.33c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvPlugChademo);
export default __webpack_public_path__ + "static/media/ev-plug-chademo.be9e35139f4d89c56431b822b80bac6e.svg";
export { ForwardRef as ReactComponent };